package components.company.pricelist.tables

import it.neckar.lizergy.model.configuration.quote.builder.HybridInverter
import it.neckar.open.collections.fastForEachIndexed
import it.neckar.open.kotlin.lang.ifNull
import it.neckar.open.kotlin.lang.toCheckboxChar
import it.neckar.open.time.formatHourAndMinutes
import kotlinx.css.*
import kotlinx.html.ThScope
import kotlinx.html.classes
import react.*
import react.dom.*
import store.hooks.useSelectPriceList
import style.toStyleClass
import styled.*

val BatteryConfigurationPriceTable: FC<Props> = fc("BatteryConfigurationPriceTable") {
  val priceList = useSelectPriceList()

  val batteryConfigurationPrices = priceList.batteryConfigurationPrices
  val batteryStorageExtraPrices = priceList.batteryStorageExtraPrices


  div("col") {
    h2 {
      +"Batteriespeicher-Systeme (Hybrid-Wechselrichter)"
    }

    table("table table-responsive table-striped") {
      thead {
        tr {
          th(ThScope.col) {
            +"#"
          }
          th(ThScope.col) {
            +"Name"
          }
          th(ThScope.col, "text-end") {
            +"Kapazität"
          }
          styledTh {
            attrs {
              classes = setOf("text-center")
            }
            css {
              maxWidth = 150.px
            }
            +"Kompatibel mit Lizergy Independence Manager"
          }
          th(ThScope.col, "text-end") {
            +"Kosten"
          }
          th(ThScope.col, "text-end") {
            +"Preis"
          }
        }
      }

      tbody {
        batteryConfigurationPrices.available.filter {
          it.inverterType is HybridInverter
        }.fastForEachIndexed { index, batteryConfiguration ->
          val battery = batteryConfiguration.battery
          val lifeCycleState = batteryConfiguration.lifeCycleState

          tr(classes = lifeCycleState.toStyleClass()) {
            key = batteryConfiguration.uuid.toString()

            th(ThScope.row) {
              +"${index + 1}"
            }
            styledTd {
              css {
                maxWidth = 250.px
              }
              +batteryConfiguration.format()
            }

            td("text-end") {
              +batteryConfiguration.totalStorage.formatKiloWattHour()
            }
            td("text-center") {
              +batteryConfiguration.compatibleWithIndependenceManager.toCheckboxChar()
            }

            td("text-end") {
              +batteryConfigurationPrices[batteryConfiguration].materialPrice.inputPrice.format().ifNull("-")
            }
            td("text-end") {
              +batteryConfigurationPrices[batteryConfiguration].materialPrice.sellingPrice.format().ifNull("-")
            }
          }

          if (battery != null) {
            tr(classes = lifeCycleState.toStyleClass()) {
              th(ThScope.row) {}
              styledTd {
                css {
                  maxWidth = 250.px
                }
                +"Kleinteile und Zubehör"
              }

              td("text-end") {}
              td("text-center") {}

              td("text-end") {
                +batteryStorageExtraPrices[battery].inputPrice.format().ifNull("-")
              }
              td("text-end") {
                +batteryStorageExtraPrices[battery].sellingPrice.format().ifNull("-")
              }
            }
          }

          tr(classes = lifeCycleState.toStyleClass()) {
            td {
            }
            th(ThScope.row) {
              +"Arbeitszeit:"
            }
            td("text-end") {
              +batteryConfigurationPrices[batteryConfiguration].workingTimes.workingTime.formatHourAndMinutes().ifNull("-")
            }
            td("text-center") {
            }

            td("text-end") {
              +batteryConfigurationPrices[batteryConfiguration].workingTimes.priceWithProfit.inputPrice.format().ifNull("-")
            }
            td("text-end") {
              +batteryConfigurationPrices[batteryConfiguration].workingTimes.priceWithProfit.sellingPrice.format().ifNull("-")
            }
          }

          tr(classes = lifeCycleState.toStyleClass()) {
            td {
            }
            th(ThScope.row) {
              b { +"Gesamt:" }
            }
            td("text-end") {
            }
            td("text-center") {
            }

            td("text-end") {
              b {
                var inputPrice = batteryConfigurationPrices[batteryConfiguration].inputPrice
                if (battery != null) inputPrice += batteryStorageExtraPrices[battery].inputPrice
                +inputPrice.format().ifNull("-")
              }
            }
            td("text-end") {
              b {
                var sellingPrice = batteryConfigurationPrices[batteryConfiguration].sellingPrice
                if (battery != null) sellingPrice += batteryStorageExtraPrices[battery].sellingPrice
                +sellingPrice.format().ifNull("-")
              }
            }
          }

        }
      }
    }

    hr("my-5") {}

    h2 {
      +"Batteriespeicher-Systeme (Batterie-Wechselrichter)"
    }

    table("table table-responsive table-striped") {
      thead {
        tr {
          th(ThScope.col) {
            +"#"
          }
          th(ThScope.col) {
            +"Name"
          }
          th(ThScope.col, "text-end") {
            +"Kapazität"
          }
          styledTh {
            attrs {
              classes = setOf("text-center")
            }
            css {
              maxWidth = 150.px
            }
            +"Kompatibel mit Lizergy Independence Manager"
          }
          th(ThScope.col, "text-end") {
            +"Kosten"
          }
          th(ThScope.col, "text-end") {
            +"Preis"
          }
        }
      }

      tbody {
        batteryConfigurationPrices.available.filter {
          it.inverterType !is HybridInverter
        }.fastForEachIndexed { index, batteryConfiguration ->
          val lifeCycleState = batteryConfiguration.lifeCycleState

          tr(classes = lifeCycleState.toStyleClass()) {
            key = batteryConfiguration.uuid.toString()

            th(ThScope.row) {
              +"${index + 1}"
            }
            styledTd {
              css {
                maxWidth = 250.px
              }
              +batteryConfiguration.format()
            }

            td("text-end") {
              +batteryConfiguration.totalStorage.formatKiloWattHour()
            }
            td("text-center") {
              +batteryConfiguration.compatibleWithIndependenceManager.toCheckboxChar()
            }

            td("text-end") {
              +batteryConfigurationPrices[batteryConfiguration].materialPrice.inputPrice.format().ifNull("-")
            }
            td("text-end") {
              +batteryConfigurationPrices[batteryConfiguration].materialPrice.sellingPrice.format().ifNull("-")
            }
          }

          tr(classes = lifeCycleState.toStyleClass()) {
            td {
            }
            th(ThScope.row) {
              +"Arbeitszeit:"
            }
            td("text-end") {
              +batteryConfigurationPrices[batteryConfiguration].workingTimes.workingTime.formatHourAndMinutes().ifNull("-")
            }
            td("text-center") {
            }

            td("text-end") {
              +batteryConfigurationPrices[batteryConfiguration].workingTimes.priceWithProfit.inputPrice.format().ifNull("-")
            }
            td("text-end") {
              +batteryConfigurationPrices[batteryConfiguration].workingTimes.priceWithProfit.sellingPrice.format().ifNull("-")
            }
          }

          tr(classes = lifeCycleState.toStyleClass()) {
            td {
            }
            th(ThScope.row) {
              b { +"Gesamt:" }
            }
            td("text-end") {
            }
            td("text-center") {
            }

            td("text-end") {
              b { +batteryConfigurationPrices[batteryConfiguration].inputPrice.format().ifNull("-") }
            }
            td("text-end") {
              b { +batteryConfigurationPrices[batteryConfiguration].sellingPrice.format().ifNull("-") }
            }
          }

        }
      }
    }

  }
}
